export default __webpack_public_path__ + "static/media/login-visual2.6cffb4d1.jpg";